import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GetSalesInsightsGroupedRequest, SalesInsightsGroupedResponse, useSalesInsightsGrouped } from '../../../../api/indicators';
import { UserContext } from '../../../../context/UserContext';
import { DashboardFiltersContext } from '../filters/DashboardFiltersContext';
import { dateRange } from '../../../../helpers/dateUtils';
import PieBarChart, { PieBarChartData } from '../charts/PieBarChart';
import { DashboardContext } from '../../DashboardContext';


const SalesByStaff = () => {
    const { t } = useTranslation();
    const { locale } = useContext(UserContext);
    const { filters, dateRangeConfig } = useContext(DashboardFiltersContext);
    const { refreshDate } = useContext(DashboardContext);
    const [ params, setParams ] = useState<GetSalesInsightsGroupedRequest>({
        fields: 'netSales',
        startDateTime: filters.periodFrom ? filters.periodFrom : dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate,
        endDateTime:filters.periodTo ? filters.periodTo : dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate,
        locations: filters?.locations?.join(','),
        locationArea: filters?.locationArea?.id,
        groupBy: 'staff'
    });

    const {
        data: groupedSalesInsightsResponse,
        isLoading,
        isError,
        refetch: fetchSalesInsightsGrouped
    } = useSalesInsightsGrouped<SalesInsightsGroupedResponse>(params, 'sales-insights/grouped');

    useEffect(() => {
        setParams(p => ({
            ...p,
            startDateTime: filters.periodFrom || dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate,
            endDateTime:filters.periodTo || dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate,
            locations: filters?.locations?.join(','),
            locationArea: filters?.locationArea?.id
        }));
    }, [filters, dateRangeConfig]);

    useEffect(() => {fetchSalesInsightsGrouped();}, [params, fetchSalesInsightsGrouped]);

    useEffect(() => {
        if (refreshDate != null) {
            fetchSalesInsightsGrouped();
        }
    }, [refreshDate, fetchSalesInsightsGrouped]);

    return (
        <PieBarChart
            title={t("screens.dashboarding.charts.netSalesByStaff")}
            description={t("screens.dashboarding.charts.includingTax")}
            data={groupedSalesInsightsResponse?.salesInsightsGrouped?.map(v => ({
                value: v.salesInsights.netSalesIncTax,
                label: v.key,
            })) as PieBarChartData[]}
            currency={groupedSalesInsightsResponse?.currency}
            locale={locale}
            isLoading={isLoading}
            error={isError}
            reportName={t('screens.dashboarding.charts.netSalesByStaff')}
            reportLink={`${process.env.REACT_APP_LINK_BACK_OFFICE}Pages/Reporting/SalesByEmployee.aspx`}
        />
    )
}

export default SalesByStaff;
